import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Button as ActionButton, FileInput, FileField } from 'react-admin'
import { withStyles } from '@material-ui/core/styles'
import compose from 'recompose/compose'

import axios from 'axios'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'

import ButtonIcon from '@material-ui/icons/CloudUpload'

import MessageSnackbar from './MessageSnackbar'

import httpClient from '../../utils/httpClient'

import _ from 'lodash'


const styles = theme => ({
    title : {
        display: 'inline-flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        fontSize: 23,
        '& svg' : { color: '#019EAC', paddingRight : 10 }
    },

})


const BULK_LOAD_EXCEL_BASE_URL = `${process.env.API_URL}/api/v1/carga_masiva_excel_instalaciones`
// const EXCEL_ACCEPT = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
const MAX_SIZE = 1024 * 1024 * 10
const Messages = {
    SUCCESS : 'success',
    WARNING : 'warning',
    ERROR : 'error'
}

class UploadBulkLoadInstalacionExcel extends Component {

    state = {
        progress: 0,
        dialogOpen: false,
        loading: false,
        message: null,
        messages_list: [],
        funcSetInterval: (func, time) => setInterval(func, time * 1000),
        funcSetIntervalProcess: null
    }

    handleDialogOpen = () => {
        this.setState({ dialogOpen: true, message : null,  messages_list : [] })
    }

    handleDialogClose = () => {
        this.setState({
          progress: 0,
          dialogOpen: false,
          loading: false,
          message: null,
          messages_list : [],
          funcSetIntervalProcess: null
        })
    }

    funcClearInterval = () => {
      const { funcSetIntervalProcess } = this.state
      clearInterval(funcSetIntervalProcess)
    }

    handleExcelUpload = async (values) => {
        const { resource } = this.props
        const { funcSetInterval } = this.state
        this.setState({ loading : true, message : null,  messages_list : [] })
        const { funcClearInterval } = this

        let file = _.get(values, 'excel_file.rawFile')

        if(file){
            let formData = new FormData()
            formData.append("excel_file", file)

            let headers = { Accept: 'application/json' }
            const accessToken = localStorage.getItem('accessToken')
            if (!!accessToken) {
              headers.Authorization = `Bearer ${accessToken}`
            }

            const url = `${BULK_LOAD_EXCEL_BASE_URL}/${resource}/upload_excel/`
            const resUpload = await axios({
              url,
              method: 'put',
              data: formData,
              headers
            })
            
            const { data: { mensaje,status,errores } } = resUpload
            let tipo = Messages.SUCCESS
            if(status == 'with_errors'){
              tipo = Messages.ERROR
            }
            else if(errores > 0){
              tipo = Messages.WARNING
            }

      
            this.setState({ 
              progress : 1 ,
              loading : false, 
              message : {
                type : tipo,
                text : mensaje
              },
              messages_list : []
            })
            funcClearInterval()

        } else {
            this.setState({ 
                loading : false, 
                message : {
                    type : Messages.ERROR,
                    text : 'Debe subir un archivo Excel válido.'
                },
            })
        }
    }

    render() {

        const { classes, handleSubmit } = this.props
        const { dialogOpen, loading, message, messages_list, progress } = this.state

        return (
            <Fragment>
                <ActionButton label={"Subir Excel Instalaciones"} onClick={this.handleDialogOpen} >
                    <ButtonIcon/>
                </ActionButton>
                <Dialog
                    open={dialogOpen}
                    onClose={this.handleDialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    >
                    <form onSubmit={handleSubmit(values => this.handleExcelUpload(values))} >
                        <DialogTitle>
                            <Typography className={classes.title}>
                                <ButtonIcon/> Subir Excel Carga Masiva
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            {message && <MessageSnackbar variant={message.type} message={message.text}/>}
                            {messages_list.length > 0 && messages_list.map(m => (
                                <MessageSnackbar variant={"error"} message={`Fila ${m.row}: ${m.message}`}/>
                            ))}
                            {!loading &&
                            <Field 
                                name="excel_file" 
                                type="file"
                                component={props =>
                                    <FileInput 
                                        source="excel_file" 
                                        label="Excel Carga Masiva" 
                                        accept={'.xlsx'}
                                        maxSize={MAX_SIZE}
                                        placeholder={<p>Arrastra un archivo excel, o haz clic aquí para buscarlo</p>}
                                        {...props.input}
                                    >
                                        <FileField source="src" title="title" />
                                    </FileInput>
                                }
                            />}
                            {loading && <LinearProgress/>}
                            {loading && `${progress}%`}
                        </DialogContent>
                        <DialogActions>
                            {
                              !loading && (
                                <Button type="submit" color="primary" >
                                  Subir Excel
                                </Button>
                              )
                            }
                            <Button onClick={this.handleDialogClose} color="secondary">
                                Cerrar
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </Fragment>
        )
    }

}


const enhance = compose(
    connect( null, {}),
    reduxForm({
        form: 'redux-form'
    }),
    withStyles(styles),
)
export default enhance(UploadBulkLoadInstalacionExcel)
